import { render, staticRenderFns } from "./result-badge.vue?vue&type=template&id=675da150"
import script from "./result-badge.vue?vue&type=script&lang=js"
export * from "./result-badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports